import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map, tap} from "rxjs/operators";
import { CommunicationConstants } from '../constants/communication';
import { MessageService } from 'primeng/api';
import { SecureStorageService } from '../services/secure-storage.service';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {

  constructor(private messageService: MessageService, private secureStorageService:SecureStorageService){}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const excludedUrls = [
        '/assets/i18n/es.json',
    ];
    const shouldExclude = excludedUrls.some(url => request.url.includes(url));
    if (shouldExclude) {
        return next.handle(request);
    }
     return next.handle(request)
           .pipe(
                map(event => {
                    if (event instanceof HttpResponse) {
                        let errorMsg: string;
                        const [codigosCom, mensajesCom] = CommunicationConstants;

                        var statusCode = event.body.statusCode;
                        var bodyMessage = JSON.parse(event.body.body);

                        if( statusCode === 400){
                            const detail = bodyMessage['Message']['DetailUser'];
                            const summary = bodyMessage['Message']['Title'];
                            this.messageService.add({severity:"error", key: 'basic-message', summary:summary, detail: detail});
                        }

                        if( statusCode === 500){
                            let message : string = "";
                            message = bodyMessage['Message']['DetailUser'];
                            errorMsg = `${codigosCom.ERROR}:${message}`;
                            throw new Error(errorMsg);
                        }
                        

                        event = event.clone({ body: JSON.parse(event.body.body) });
                    }
                    return event;
                }),
                catchError((error: HttpErrorResponse) => {
                    let errorMsg: string;
                    const [codigosCom, mensajesCom] = CommunicationConstants;
                    if (error.error instanceof ErrorEvent) {
                        errorMsg = `${codigosCom.ERRORCLT}||${mensajesCom.ERRORCLT}`;
                    } else {

                        if(error.status === 400){
                            let message = error.error?.ErrorMessage != null ? error.error?.ErrorMessage :"Se enviaron datos incorrectos al servidor.";
                            errorMsg= `${codigosCom.ERROR}:${message}`;
                            this.messageService.add({severity:"error", key: 'basic-message', summary:'400', detail: message});
                        }else if( error.status === 500){
                            this.messageService.add({severity:"error", key: 'basic-message', summary: '500', detail: mensajesCom.MSGDATAVACIOSRV});
                            errorMsg = `${codigosCom.ERROR}:${mensajesCom.MSGDATAVACIOSRV}`;
                        } else if(error.status === 401){
                            this.messageService.add({severity:"error", key: 'basic-message', summary:'401', detail: mensajesCom.MSGTIMEOUT});
                            errorMsg = `${codigosCom.TIMEOUT}:${mensajesCom.MSGTIMEOUT}`;
                        } else if(error.status === 404){
                            this.messageService.add({severity:"error", key: 'basic-message', summary:'404', detail: mensajesCom.MSG404});
                            errorMsg = `${codigosCom.ERROR}:${mensajesCom.MSG404}`;
                        } else {
                            this.messageService.add({severity:"error", key: 'basic-message', summary: 'Error de comunicación', detail: mensajesCom.MSGERRORSRV});
                            errorMsg = `${codigosCom.ERROR}:${mensajesCom.MSGERRORSRV}`;
                        }
                    }
                    throw new Error(errorMsg);
                })
           )
  }
}
